import React, { useState } from 'react'
import'./HomePage.css'

const Home = () => {

  const [count,setCount]=useState(0.0);

const style={
  counter:{
    background: '#f8c428',
    color:'#f8f8f8',
    minWidth: '20rem',
    minHeight:'5rem', 
    paddingTop:'5px',
    textShadow: '2px 2px #330033',
    fontSize:'10vw',
    marginTop:'5%',
    fontWeight:'600',
    marginLeft:'auto',
    marginRight:'auto',
    letterSpacing: '1rem',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    
  },
  i:{
  marginLeft:'5px'
  },

button:{  
  border: 'none',
  background: '#f8c428',
  color: 'rgb(32, 32, 32)',
  padding: '10px',
  borderRadius: '10px',
  width: '12vw',
  margin: '1vw',
  fontSize: 'large',
  fontWeight: '500',
  textShadow: '2px 1px white',
  minWidth: '10rem',
},

};

return (
    <>

 <div >
 <p id='nbr' className='card w-25 pb-2 ' 
 style={style.counter} >{count}</p>
 </div>

    <div className="container">
   
    <button 
    
    style={style.button}
    onClick={() =>       
      {
        if(count===0){
          alert("Counter is not started yet.")
        }else{setCount(count - 1)}
          }    }
      
    >Decrement
    <i className='fa fa-minus'  style={style.i}></i>
    </button>
    <button
    style={style.button}
    onClick={() =>  {
      if(count!==0){
        setCount(0)
        alert("Counter has been Reset Successfully.");
      }else{
        alert("Counter is alredy Reset.");
      }} }

    >Reset
    <i className='fa fa-rotate' style={style.i}></i>
    </button>
    <button
    style={style.button}
    onClick={() => {
  setCount(count + 1)

}}>
  Increment
    <i className='fa fa-plus'  style={style.i}></i></button>
   </div>
  </>
  )
}


export default Home;
